import Layout from '@/component/layout'
import React, { Component } from 'react'
import { Poppins,Quicksand } from 'next/font/google'
import NextSeoModule from '../component/next-seo';
import Link from 'next/link';
const popins=Poppins({weight:"500",subsets:['latin']});
const quicksand=Quicksand({weight:"400",subsets:['latin']});
export class refund extends Component {

  render() {
    const refund = [
      {
        title:"Information We Collect",
        cnt:"We collect personal information such as your name, email address, and payment details when you place an order or sign up for our newsletter."
      },
      {
        title:"  How We Use Your Information",
        cnt:"We use your information to process your orders, communicate with you, and improve our services."
      },
      {
        title:" Cookies",
        cnt:"We use cookies to personalize content, analyze our traffic, and improve your browsing experience."
      },
      {
        title:" Data Security",
        cnt:"We take precautions to protect your information both online and offline."
      },
      {
        title:" Changes to This Privacy Policy",
        cnt:"We reserve the right to update or change our Privacy Policy at any time."
      }

    ]
    const terms = [
      {
        title:"Acceptance of Terms",
        cnt:`By accessing or using <a href="https://www.learnsoft.org/"> Learnsoft.org </a> website  , you agree to be bound by these Terms.`
      },
      {
        title:" User Conduct",
        cnt:"You agree not to engage in any activity that disrupts or interferes with the functioning of the website or its services."
      },
      {
        title:" Intellectual Property ",
        cnt:"All content and materials available on the website are protected by intellectual property laws."
      },
      {
        title:"  Limitation of Liability",
        cnt:"LEARN SOFT ORG  shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your access to or use of the website."
      },
      {
        title:"Indemnification",
        cnt:"You agree to indemnify and hold harmless from any claims, losses,liabilities, damages, costs, and expenses arising out of or relating to your use of the website."
      },
      {
        title:"Governing Law",
        cnt:"These Terms and Conditions shall be governed by and construed in accordance with the laws of INDIA.."
      }

    ]
    return (
      <>
        <NextSeoModule
            title="Refund Policy - learnsoft.org"
            description="Unlock Peace of Mind! Discover the Ultimate Refund Policy at learnsoft.org - Your Satisfaction Guaranteed! Explore Now! "
            url="refund"
            breadcrumbs={"Refund"}
          />
      <Layout navbarBackgroundColor="#281E1E">
      <section className='breadcrumb-bg'>
        <div className='container df fac fjc'>
         <div className='df fjc fdc'>   
        <h4 className={`fs-33 mfs-19 cw mtac ${popins.className}`}>Refund Policy</h4>
        </div>
        </div>
    </section>
      <div className="container pdb50">
      <h2 className={`mb-3 pdt100 fwb fs30 ${popins.className}`}>Privacy Policy</h2>
      {refund.map((items,index)=>{
        return(
      <div className='mt16'key={index}>
      <h3 className={`fs-24 mfs-18 ${popins.className}`}>{index + 1}. {items.title}</h3>
      <p className={`fs-16 mfs-15 mt12 ${quicksand.className}`}>{items.cnt}</p>
      </div>
      )
    })}
       <h2 className={`mb-3 mt24 fwb fs30 ${popins.className}`}>Terms and Conditions</h2>
       <p className={`fs-16 mfs-15 mt12 ${quicksand.className}`}>This website is operated by <Link href={"https://www.learnsoft.org/"}>Learnsoft.org</Link>  Throughout the site, the terms “we”, “us” and “our” refer to <Link href={"https://www.learnsoft.org/"}>Learnsoft.org</Link> offers this website, including all information, tools and Services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here</p>
       {terms.map((items,index)=>{
        return(
      <div className='mt16'key={index}>
      <h3 className={`fs-24 mfs-18 ${popins.className}`}>{index + 1}. {items.title}</h3>
      <p className={`fs-16 mfs-15 mt12 ${quicksand.className}`}dangerouslySetInnerHTML={{ __html: items.cnt }}></p>
      </div>
      )
    })}
     <p className={`fs-16 mfs-15 mt12 fwb ${popins.className}`}>Refund Policy</p>
     <p className={`fs-16 mfs-15 mt12 ${quicksand.className}`}>If refund is approved, the amount will be credited to the customer's account in 8-10working days.</p>
     <p className={`fs-16 mfs-15 mt12 ${quicksand.className}`}>This is website Managed by <strong> ABDUL GHANI </strong> </p>
    </div>
  </Layout>
  <style jsx>
        {`
        .breadcrumb-bg{
        background-image: url('/breadcrumb-bg.webp');
        width:100%;
        height: 211px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
       
        background-size: 100% 100%;
        }
        @media only screen and (max-width: 1023px){
                .breadcrumb-bg{
        background-image: url('/breadcrumb-bg.webp');
        width:100%;
        height: auto;
        padding: 20px 0px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
        }
        }
        
        `}
    </style>
  </>
    )
  }
}

export default refund